const awards = [
    {
        id: 1,
        type: "award",
        title: "2025 Winner of the Windrush I Accelerator Program",
        issuer: "Microsoft UK and UWI",
        issued: "June 2025"
    },
    {
        id: 2,
        type: "award",
        title: "3rd Place - Barbados AI Fraud Detection Hackathon - Zindi",
        issuer: "Zindi",
        issued: "May 2025"
    },
    {
        id: 3,
        type: "award",
        title: "Faculty of Science & Technology Student Award",
        issuer: "FST, UWI",
        issued: "Oct 2022"
    },
    {
        id: 4,
        type: "award",
        title: "Faculty of Science & Technology Student Award",
        issuer: "FST, UWI",
        issued: "Oct 2023"
    },
    {
        id: 5,
        type: "award",
        title: "Incentive Award for Excellence In Visual Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "Nov 2019"
    },
    {
        id: 6,
        type: "award",
        title: "Gold Award for 'Ayana' - Fine Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "Nov 2019"
    },
    {
        id: 7,
        type: "award",
        title: "Gold Award for 'Angela Lansbury' - Fine Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "November 2019"
    },
    {
        id: 8,
        type: "award",
        title: "Silver Award for 'Polar Paradise' - Fine Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "Nov 2019"
    },
    {
        id: 9,
        type: "award",
        title: "Silver Award for 'Like An Hourglass' - Fine Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "Nov 2024"
    },
    {
        id: 10,
        type: "award",
        title: "Bronze Award for 'Grounded' - Fine Arts",
        issuer: "National Independence Festival of Creative Arts",
        issued: "Nov 2024"
    }, 
    {
        id: 11,
        type: "certificate",
        title: "JavaScript Basics",
        issuer: "Coursera",
        issued: "Aug 2022"
    }, 
    {
        id: 12,
        type: "certificate",
        title: "AngularJS for Beginners",
        issuer: "SoloLearn",
        issued: "Jun 2023"
    }, 
    {
        id: 13,
        type: "certificate",
        title: "Game Development with JS",
        issuer: "SoloLearn",
        issued: "May 2022"
    }, 
    {
        id: 14,
        type: "certificate",
        title: "Knowledge Management",
        issuer: "Info-Tech Academy",
        issued: "Jun 2023"
    },
    {
        id: 15,
        type: "certificate",
        title: "Requirements Gathering",
        issuer: "Info-Tech Academy",
        issued: "Jun 2023"
    },
    {
        id: 16,
        type: "certificate",
        title: "Organizational Change Management",
        issuer: "Info-Tech Academy",
        issued: "Jun 2023"
    },
    {
        id: 17,
        type: "certificate",
        title: "Vendor Management",
        issuer: "Info-Tech Academy",
        issued: "Jun 2023"
    },
]

export default awards